import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { forwardRef, Fragment } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import { Text } from '@atlaskit/primitives';
/* eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports */
import { transformTimeStamp } from '../../../transformTimeStamp';
import { composeListItemStyles, imgStyles, itemIconStyles, itemNameStyles, listItemContainerInnerStyles, listItemContainerStyles, listItemContextStyles } from './styled';
export var testIds = {
  searchResultItem: 'link-search-list-item',
  searchResultIcon: 'link-search-list-item-icon'
};
var isSVG = function isSVG(icon) {
  return icon.startsWith('<svg') && icon.endsWith('</svg>');
};
var base64SVG = function base64SVG(icon) {
  return "data:image/svg+xml;base64,".concat(Buffer.from(icon).toString('base64'));
};
var ListItemIcon = function ListItemIcon(props) {
  var item = props.item,
    intl = props.intl;
  var icon = item.icon,
    iconAlt = item.iconAlt;
  if (!icon) {
    return null;
  }
  var alt = typeof iconAlt === 'string' ? iconAlt : intl.formatMessage(iconAlt);
  if (typeof icon !== 'string') {
    var Glyph = icon;
    return (
      // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      jsx("span", {
        css: itemIconStyles
      }, jsx(Glyph, {
        alt: alt,
        "data-testid": testIds.searchResultIcon
      }))
    );
  }
  return (
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    jsx("span", {
      css: itemIconStyles
    }, jsx("img", {
      "data-testid": testIds.searchResultIcon,
      src: isSVG(icon) ? base64SVG(icon) : icon,
      alt: alt
      // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      ,
      css: imgStyles
    }))
  );
};
var ListItemSubtitle = function ListItemSubtitle(_ref) {
  var _ref$items = _slicedToArray(_ref.items, 2),
    firstItem = _ref$items[0],
    secondItem = _ref$items[1];
  return /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */(
    jsx("div", {
      "data-testid": "".concat(testIds.searchResultItem, "-subtitle"),
      css: listItemContextStyles
    }, jsx("div", {
      css: listItemContainerStyles
    }, jsx("span", {
      css: listItemContainerInnerStyles
    }, firstItem)), secondItem && jsx("div", {
      css: listItemContainerInnerStyles
    }, jsx(Fragment, null, "\xA0 \u2022\xA0 "), jsx(Fragment, null, secondItem)))
  );
  /* eslint-enable @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */
};
var getDefaultSubtitleItems = function getDefaultSubtitleItems(item, intl) {
  var container = item.container;
  var date = transformTimeStamp(intl, item.lastViewedDate, item.lastUpdatedDate);
  if (container) {
    if (date) {
      return [container, date];
    }
    return [container];
  }
  if (date) {
    return [date];
  }
  return undefined;
};
export var LinkSearchListItem = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var item = _ref2.item,
    selected = _ref2.selected,
    id = _ref2.id,
    role = _ref2.role,
    onSelect = _ref2.onSelect,
    tabIndex = _ref2.tabIndex,
    onKeyDown = _ref2.onKeyDown,
    onFocus = _ref2.onFocus,
    _ref2$nameMaxLines = _ref2.nameMaxLines,
    nameMaxLines = _ref2$nameMaxLines === void 0 ? 1 : _ref2$nameMaxLines;
  var intl = useIntl();
  var handleSelect = function handleSelect() {
    return onSelect(item.objectId);
  };
  var subtitleItems = item.subtitleItems || getDefaultSubtitleItems(item, intl);
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    jsx("div", {
      // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      css: composeListItemStyles(selected),
      role: role,
      id: id,
      "aria-selected": selected,
      "data-testid": testIds.searchResultItem,
      onKeyDown: onKeyDown,
      onClick: handleSelect,
      onFocus: onFocus,
      tabIndex: tabIndex,
      ref: ref
    }, jsx(ListItemIcon, {
      item: item,
      intl: intl
    }), jsx("div", {
      css: itemNameStyles
    }, jsx(Text, {
      maxLines: nameMaxLines
    }, jsx("span", {
      "data-testid": "".concat(testIds.searchResultItem, "-title"),
      title: item.name
    }, item.name)), subtitleItems && jsx(ListItemSubtitle, {
      items: subtitleItems
    })))
  );
});